<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-select 
						v-model="filters.cpcode" filterable placeholder="请选择渠道" class="h-m-select">
					  <el-option v-for="item in cplist"
						:key="item.code" :label="item.name" v-model="item.code">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column prop="entime" label="时间" min-width="100"></el-table-column>
			<el-table-column prop="alis_index" label="别名" min-width="100">
				<template slot-scope="scope"><span v-html="formateData(scope.row)"></span></template>
			</el-table-column>
			<el-table-column prop="sites" label="Site" min-width="150">
				<template slot-scope="scope"><span v-html="formateSites(scope.row)"></span></template>
			</el-table-column>
			<el-table-column prop="sname" label="SP" min-width="80"></el-table-column>
			<el-table-column label="操作" fixed="right" width="120">
				<template slot-scope="scope">
					<div>
						<el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="addEdit(scope.$index, scope.row)">Add数据</el-button>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="revenue" label="数据" min-width="200">
				<template slot-scope="scope">
					{{scope.row.revenue1+'|'+scope.row.revenue2+'|'+scope.row.revenue3+'|'+scope.row.revenue4+'|'+scope.row.revenue5}}
				</template>
			</el-table-column>
		</el-table>

		<!--编辑界面-->
		<el-dialog :title="editformtitle" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
				<el-form-item label="别名" prop="alis_index">
					<el-input v-model="editForm.alis_index" placeholder="别名"></el-input>
				</el-form-item>
				<el-form-item label="站点" prop="sites">
					<el-input v-model="editForm.sites" placeholder="站点"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					cpcode:''
				},
				cplist:[],
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					code :[
						{required: true,message: '编号不能为空!',trigger: 'blur'}
					],
					name :[
						{required: true,message: '名称不能为空!',trigger: 'blur'}
					],
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',sites:'',alis_index:'',id:''
				}
			}
		},
		methods: {
			formateData:function(row){
				return (`<span style="color:${row.thecolor}">${row.alis_index}</span>`)
			},
			formateSites:function(row){
				return (`<span style="color:${row.thecolor}">${row.sites}</span>`)
			},
			getCpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'html_cpinfo.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.cplist = res.data.datas;
					}
				});
				
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getLists();
			},
			formatValid: function (row, column) {
				return row.valid == 1 ? '有效' : row.valid == 0 ? '无效' : '未知';
			},
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'datas/getSiteManList',
					cpcode:this.filters.cpcode
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'html_sites.uptAlis';
			},
			addEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '添加数据';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'html_sites.uptAlis';
			},
			editSubmit:function(){
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			}
		},
		mounted() {
			this.getCpList();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// sitesinfoManager.vue?ee1f9100